import React from 'react';

class VoucherLinkingModal extends React.Component {
    state = {
        index: 0,
        voucherData: {},
        linkedDeliveries: {},
        saving: false,
        showSummary: false
    };

    get currentVoucher() {
        return this.props.vouchers?.[this.state.index];
    }

    handleChange = (field, value) => {
        const { index, voucherData } = this.state;
        this.setState({
            voucherData: {
                ...voucherData,
                [index]: {
                    ...(voucherData[index] || {}),
                    [field]: value
                }
            }
        });
    };

    toggleDelivery = (id) => {
        const { index, linkedDeliveries } = this.state;
        const current = linkedDeliveries[index] || [];

        this.setState({
            linkedDeliveries: {
                ...linkedDeliveries,
                [index]: current.includes(id)
                    ? current.filter(d => d !== id)
                    : [...current, id]
            }
        });
    };

    next = () => {
        if (this.state.index < this.props.vouchers.length - 1) {
            this.setState({ index: this.state.index + 1 });
        }
    };

    prev = () => {
        if (this.state.index > 0) {
            this.setState({ index: this.state.index - 1 });
        }
    };

    saveAll = async () => {
        this.setState({ saving: true });

        try {
            const { vouchers, onSave } = this.props;
            const { voucherData, linkedDeliveries } = this.state;

            const payload = vouchers.map((v, i) => ({
                ...v,
                ...voucherData[i],
                delivery_ids: linkedDeliveries[i] || []
            }));

            await onSave(payload);
            window.$('#voucherLinkingModal').modal('hide');
        } catch (e) {
            console.error(e);
        } finally {
            this.setState({ saving: false });
        }
    };

    renderSummary() {
        const { vouchers, deliveries } = this.props;
        const { voucherData, linkedDeliveries } = this.state;

        return (
            <div>
                <h5 className="mb-3 font-weight-bold">Resumen de vinculación</h5>

                {vouchers.map((v, i) => {
                    const data = voucherData[i] || {};
                    const linked = linkedDeliveries[i] || [];

                    const total = linked.reduce((sum, id) => {
                        const d = deliveries.find(x => x.id === id);
                        return sum + (d?.total_amount || 0);
                    }, 0);

                    return (
                        <div key={i} className="border rounded p-3 mb-3">
                            <div className="font-weight-bold mb-1">
                                {v.voucher_number}
                            </div>
                            <div>Monto: ${data.amount || v.amount}</div>
                            <div>Pedidos vinculados: {linked.length}</div>
                            <div className="text-success font-weight-bold">
                                Total: ${total.toFixed(2)}
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    render() {
        const { deliveries, vouchers } = this.props;
        const { index, saving, showSummary, voucherData, linkedDeliveries } = this.state;
        const voucher = this.currentVoucher;

        if (!voucher) return null;

        const data = voucherData[index] || {};
        const linked = linkedDeliveries[index] || [];

        return (
            <div
                className="modal fade"
                id="voucherLinkingModal"
                tabIndex="-1"
                data-backdrop="static"
            >
                <div className="modal-dialog modal-xl modal-dialog-centered">
                    <div className="modal-content" style={{ borderRadius: 14 }}>

                        {/* HEADER */}
                        <div className="modal-header">
                            <h5 className="modal-title font-weight-bold">
                                {showSummary
                                    ? 'Resumen de Vinculación'
                                    : `Vincular comprobantes (${index + 1}/${vouchers.length})`}
                            </h5>
                            <button className="close" data-dismiss="modal">
                                <span>&times;</span>
                            </button>
                        </div>

                        {/* BODY */}
                        <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                            {showSummary ? (
                                this.renderSummary()
                            ) : (
                                <div className="row">
                                    {/* VOUCHER */}
                                    <div className="col-md-6">
                                        <h6 className="font-weight-bold mb-3">Comprobante</h6>

                                        <div className="border rounded p-2 mb-3 text-center">
                                            {voucher.file_url?.match(/\.(jpg|png|jpeg)$/i) ? (
                                                <img
                                                    src={voucher.file_url}
                                                    alt=""
                                                    className="img-fluid"
                                                    style={{ maxHeight: 240 }}
                                                />
                                            ) : (
                                                <a href={voucher.file_url} target="_blank" rel="noreferrer">
                                                    Ver archivo
                                                </a>
                                            )}
                                        </div>

                                        <div className="form-group">
                                            <label>Monto</label>
                                            <input
                                                className="form-control"
                                                type="number"
                                                value={data.amount || ''}
                                                onChange={e => this.handleChange('amount', e.target.value)}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Fecha</label>
                                            <input
                                                className="form-control"
                                                type="date"
                                                value={data.date || voucher.date}
                                                onChange={e => this.handleChange('date', e.target.value)}
                                            />
                                        </div>

                                        <div className="form-group">
                                            <label>Notas</label>
                                            <input
                                                className="form-control"
                                                value={data.notes || ''}
                                                onChange={e => this.handleChange('notes', e.target.value)}
                                            />
                                        </div>
                                    </div>

                                    {/* DELIVERIES */}
                                    <div className="col-md-6">
                                        <h6 className="font-weight-bold mb-3">
                                            Pedidos vinculados ({linked.length})
                                        </h6>

                                        <div style={{ maxHeight: 400, overflowY: 'auto' }}>
                                            {deliveries.map(d => (
                                                <div
                                                    key={d.id}
                                                    className={`border rounded p-2 mb-2 d-flex justify-content-between align-items-center
                                                        ${linked.includes(d.id) ? 'bg-warning-light' : ''}
                                                    `}
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => this.toggleDelivery(d.id)}
                                                >
                                                    <div>
                                                        <strong>{d.order_number}</strong>
                                                        <div className="small text-muted">
                                                            {d.customer}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        ${d.total_amount?.toFixed(2)}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* FOOTER */}
                        <div className="modal-footer d-flex justify-content-between">
                            {!showSummary ? (
                                <>
                                    <div>
                                        <button
                                            className="btn btn-outline-secondary mr-2"
                                            onClick={this.prev}
                                            disabled={index === 0}
                                        >
                                            Anterior
                                        </button>
                                        <button
                                            className="btn btn-outline-secondary"
                                            onClick={this.next}
                                            disabled={index === vouchers.length - 1}
                                        >
                                            Siguiente
                                        </button>
                                    </div>

                                    <div>
                                        <button
                                            className="btn btn-outline-secondary mr-2"
                                            onClick={() => this.setState({ showSummary: true })}
                                        >
                                            Ver resumen
                                        </button>

                                        <button
                                            className="btn botonCorrect text-white"
                                            onClick={this.saveAll}
                                            disabled={saving}
                                        >
                                            {saving ? 'Guardando...' : 'Guardar todo'}
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <button
                                        className="btn btn-outline-secondary"
                                        onClick={() => this.setState({ showSummary: false })}
                                    >
                                        Volver a edición
                                    </button>

                                    <button
                                        className="btn botonCorrect text-white"
                                        onClick={this.saveAll}
                                        disabled={saving}
                                    >
                                        {saving ? 'Guardando...' : 'Confirmar y guardar'}
                                    </button>
                                </>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

export default VoucherLinkingModal;
